// Malayalam-capable Google Fonts for the Citizen Charter.
// Extensible: add families here; TTF bytes are fetched via the backend proxy
// (/api/charters/fonts/ttf) and subset-embedded into generated PDFs.
import api from "@/lib/api";

export const MALAYALAM_FONTS = [
  { family: "Anek Malayalam", weights: [400, 500, 600, 700] },
  { family: "Noto Sans Malayalam", weights: [400, 500, 700] },
  { family: "Noto Serif Malayalam", weights: [400, 700] },
  { family: "Manjari", weights: [400, 700] },
  { family: "Chilanka", weights: [400] },
  { family: "Gayathri", weights: [400, 700] },
  { family: "Baloo Chettan 2", weights: [400, 700] },
];

export const PREVIEW_TEXT = "പൗരാവകാശ രേഖ 2026";

const loadedLinks = new Set();
export function loadFontPreview(family) {
  if (loadedLinks.has(family)) return;
  loadedLinks.add(family);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;700&display=swap`;
  document.head.appendChild(link);
}

const ttfCache = new Map();
export async function fetchFontTtf(family, weight = 400) {
  const key = `${family}:${weight}`;
  if (ttfCache.has(key)) return ttfCache.get(key);
  const { data } = await api.get(`/charters/fonts/ttf`, { params: { family, weight } });
  const bin = atob(data.base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  ttfCache.set(key, bytes);
  return bytes;
}
